import { useMemo } from 'react';
import { applyExcelFormats } from '../../../../utils/excel';
import { SIGNUP_FUNNEL_COLUMNS } from '../../../../constants/reports';
import { exportReportFile, processReport } from '../../../../utils/reports';
import ReportList from '../ReportList';
import ReportActionRow from '../ReportActionRow';

function ReportSignupFunnel({
  reportTitle,
  reportDetails,
  reportId,
  reportFileName,
  reportType,
  setSpinner,
  report,
}) {
  const { processedReport } = useMemo(
    () => processReport(reportType, report),
    [reportType, report],
  );

  const formattedReport = useMemo(() => {
    if (processedReport.length > 0) {
      return processedReport.map(r =>
        Object.entries(r).reduce(
          (acc, [key, value]) => ({
            ...acc,
            [key]: applyExcelFormats(value, SIGNUP_FUNNEL_COLUMNS[key]?.style?.numFmt),
          }),
          {},
        ),
      );
    }

    return [];
  }, [processedReport]);

  return (
    <>
      <ReportActionRow
        reportTitle={reportTitle}
        reportDetails={reportDetails}
        reportId={reportId}
        setSpinner={setSpinner}
        exportFile={() => exportReportFile({ reportType, reportFileName, report })}
      />
      <ReportList
        report={formattedReport}
        tableColumns={SIGNUP_FUNNEL_COLUMNS}
        headerHeight={36}
        boldTotalRow
        rowKey="aggId"
      />
    </>
  );
}

export default ReportSignupFunnel;
